import { Link } from 'react-router-dom';
import { useState } from 'react';
import useIsMobile from '../hooks/useIsMobile';

const bg = '#f0ebe3';
const red = '#6B1A1A';
const body = 'Cormorant Garamond, serif';

function Navbar() {
  const isMobile = useIsMobile();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav style={{ backgroundColor: bg, borderBottom: '0.5px solid #d4c9bc', position: 'relative' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: isMobile ? '20px 24px' : '28px 60px' }}>
        <Link to="/" style={{ color: red, fontSize: isMobile ? '11px' : '13px', letterSpacing: '3px', textDecoration: 'none', fontFamily: body, fontWeight: '400' }}>
          HERMES PARTNER CAPITAL
        </Link>
        {isMobile ? (
          <div onClick={() => setMenuOpen(!menuOpen)} style={{ fontSize: '22px', color: red, cursor: 'pointer' }}>
            {menuOpen ? '✕' : '☰'}
          </div>
        ) : (
          <div style={{ display: 'flex', gap: '32px', alignItems: 'center' }}>
            <Link to="/services" style={{ color: '#2a1a1a', fontSize: '12px', letterSpacing: '2px', textDecoration: 'none', fontFamily: body }}>Services</Link>
            <Link to="/contact" style={{ color: '#2a1a1a', fontSize: '12px', letterSpacing: '2px', textDecoration: 'none', fontFamily: body }}>Contact</Link>
            <Link to="/login" style={{ color: red, fontSize: '12px', letterSpacing: '2px', textDecoration: 'none', fontFamily: body, border: '0.5px solid #6B1A1A', padding: '8px 20px' }}>Login</Link>
          </div>
        )}
      </div>
      {isMobile && menuOpen && (
        <div style={{ backgroundColor: bg, borderTop: '0.5px solid #d4c9bc', padding: '20px 24px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <Link to="/services" onClick={() => setMenuOpen(false)} style={{ color: '#2a1a1a', fontSize: '14px', letterSpacing: '2px', textDecoration: 'none', fontFamily: body }}>Services</Link>
          <Link to="/contact" onClick={() => setMenuOpen(false)} style={{ color: '#2a1a1a', fontSize: '14px', letterSpacing: '2px', textDecoration: 'none', fontFamily: body }}>Contact</Link>
          <Link to="/login" onClick={() => setMenuOpen(false)} style={{ color: red, fontSize: '14px', letterSpacing: '2px', textDecoration: 'none', fontFamily: body, border: '0.5px solid #6B1A1A', padding: '10px 20px', textAlign: 'center' }}>Login</Link>
        </div>
      )}
    </nav>
  );
}

export default Navbar;